<div class="badge badge-danger mt-1 " [hidden]="hidden" [ngClass]="{'fieldFeedback' : hidden}"><i
        class="ft-alert-circle align-middle me-1"></i>{{feedbackMessage}}</div>